/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrariPianificazioneResDto } from '../../models/orari-pianificazione-res-dto';
import { PaginatedDocumented } from '../../models/paginated-documented';

export interface OrariPianificazioniControllerFindManyOrariPianificazioni$Params {
  /**
   * Page number to retrieve. If you provide invalid value the default page number will applied
   *
   * **Example:** 1
   *
   *
   * **Default Value:** 1
   */
  page?: number;

  /**
   * Number of records per page.
   *
   *
   * **Example:** 20
   *
   *
   *
   * **Default Value:** 20
   *
   *
   *
   * **Max Value:** 0
   *
   *
   * If provided value is greater than max value, max value will be applied.
   */
  limit?: number;

  /**
   * Filter by id query param.
   *
   * **Format:** filter.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.id=$eq:John Doe&filter.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.id'?: Array<string>;

  /**
   * Filter by struttura.id query param.
   *
   * **Format:** filter.struttura.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.struttura.id=$eq:John Doe&filter.struttura.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.struttura.id'?: Array<string>;

  /**
   * Filter by dal query param.
   *
   * **Format:** filter.dal={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.dal=$eq:John Doe&filter.dal=$gte:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gte
   *
   * - $lte
   *
   * - $and
   *
   * - $or
   */
  'filter.dal'?: Array<string>;

  /**
   * Filter by al query param.
   *
   * **Format:** filter.al={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.al=$eq:John Doe&filter.al=$gte:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gte
   *
   * - $lte
   *
   * - $and
   *
   * - $or
   */
  'filter.al'?: Array<string>;

  /**
   * Parameter to sort by.
   * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
   *
   * **Format:** {fieldName}:{DIRECTION}
   *
   *
   * **Example:** sortBy=id:DESC&sortBy=struttura.id:DESC
   *
   *
   * **Default Value:** id:ASC
   *
   * **Available Fields**
   * - id
   *
   * - struttura.id
   *
   * - turno.id
   *
   * - dal
   *
   * - al
   *
   * - oreLavoro
   */
  sortBy?: Array<
    | 'id:ASC'
    | 'id:DESC'
    | 'struttura.id:ASC'
    | 'struttura.id:DESC'
    | 'turno.id:ASC'
    | 'turno.id:DESC'
    | 'dal:ASC'
    | 'dal:DESC'
    | 'al:ASC'
    | 'al:DESC'
    | 'oreLavoro:ASC'
    | 'oreLavoro:DESC'
  >;

  /**
   * Search term to filter result values
   *
   * **Example:** John
   *
   *
   * **Default Value:** No default value
   */
  search?: string;

  /**
   * List of fields to search by term to filter result values
   *
   * **Example:** id,struttura.id,turno.id,dal,al
   *
   *
   * **Default Value:** By default all fields mentioned below will be used to search by term
   *
   * **Available Fields**
   * - id
   *
   * - struttura.id
   *
   * - turno.id
   *
   * - dal
   *
   * - al
   *
   * - oreLavoro
   */
  searchBy?: Array<string>;
}

export function orariPianificazioniControllerFindManyOrariPianificazioni(
  http: HttpClient,
  rootUrl: string,
  params?: OrariPianificazioniControllerFindManyOrariPianificazioni$Params,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<
    PaginatedDocumented & {
      data?: Array<OrariPianificazioneResDto>;
      meta?: {
        select?: Array<string>;
        filter?: {
          id?: string | Array<string>;
          'struttura.id'?: string | Array<string>;
          dal?: string | Array<string>;
          al?: string | Array<string>;
        };
      };
    }
  >
> {
  const rb = new RequestBuilder(
    rootUrl,
    orariPianificazioniControllerFindManyOrariPianificazioni.PATH,
    'get',
  );
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.id', params['filter.id'], {});
    rb.query('filter.struttura.id', params['filter.struttura.id'], {});
    rb.query('filter.dal', params['filter.dal'], {});
    rb.query('filter.al', params['filter.al'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<
          PaginatedDocumented & {
            data?: Array<OrariPianificazioneResDto>;
            meta?: {
              select?: Array<string>;
              filter?: {
                id?: string | Array<string>;
                'struttura.id'?: string | Array<string>;
                dal?: string | Array<string>;
                al?: string | Array<string>;
              };
            };
          }
        >;
      }),
    );
}

orariPianificazioniControllerFindManyOrariPianificazioni.PATH =
  '/admin/orarioPianificazione';
